import {EventEmitter, Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../loader.service";
import {GAMES_CONFIG} from "../../config/api";

@Injectable({
  providedIn: 'root'
})
export class GamesPlaygroundService {
  private config = GAMES_CONFIG;
  private games = [];
  updateGames = new EventEmitter<string>();
  onGamesUpdated = new EventEmitter<number>();

  constructor(private http: HttpClient, public loaderService: LoaderService) {}

  getPageInfo(game_short_name?) {
    //this.loaderService.show();
    return this.http.post<any>(this.config.getPageInfo, {game_short_name});
  }

  setGames(games) {
    this.games = games;
  }
  getGames() {
    return this.games.filter(game => !game.default);
  }

  getSelectedProvider() {
    if (this.games.length) {
      return this.games.find(game => game.default);
    }
    return {}
  }

  getSelectedProviderId() {
    if (this.getSelectedProvider() && this.getSelectedProvider().id) {
      return this.getSelectedProvider().id;
    }
  }

  getSelectedProviderName() {
    if (this.getSelectedProvider() && this.getSelectedProvider().name) {
      return this.getSelectedProvider().name;
    }
  }

  getSelectedProviderShortName() {
    if (this.getSelectedProvider() && this.getSelectedProvider().short_name) {
      return this.getSelectedProvider().short_name;
    }
  }

  getSelectedProviderAccount() {
    if (this.getSelectedProvider() && this.getSelectedProvider().account) {
      return this.getSelectedProvider().account;
    }
  }

  getSelectedProviderPassword() {
    if (this.getSelectedProvider() && this.getSelectedProvider().password) {
      return this.getSelectedProvider().password;
    }
  }

  getSelectedProviderGDPassword() {
    if (this.getSelectedProvider() && this.getSelectedProvider().gd_password) {
      return this.getSelectedProvider().gd_password;
    }
  }

  getSelectedProviderPin() {
    if (this.getSelectedProvider() && this.getSelectedProvider().pin) {
      return this.getSelectedProvider().pin;
    }
  }

  getSelectedProviderMobileId() {
    if (this.getSelectedProvider() && this.getSelectedProvider().gd_mobile_id) {
      return this.getSelectedProvider().gd_mobile_id;
    }
  }
}
